// extracted by mini-css-extract-plugin
export default {"productGallery":"sP-z","inQuickShop":"tP-z"};